export default __webpack_public_path__ + "static/log-axis-3d8d4e8a1a71a4ab10303e17206ac78b.png";